import { HStack, Link, Image, Box } from '@telescope/cassini-ui';
import { Text } from 'components';
import { useWidget } from '@telescope/cassini-hooks';
import { Open } from 'generated-types/widget';

export const Sponsor = () => {
  const { data: sponsor } = useWidget({ select: (data: Open) => data.snapshot.snapshot_views.sponsor });
  const { content } = sponsor!;

  if(!content.image) { return null; }

  return (
    <HStack justifyContent="center">
      <Text fontSize={{base: 'sm', md: 'md'}} fontWeight="700"> {content.text} </Text>
      <Link href={content.imageLink} isExternal className="Sponsor__link">
        <Image src={content.image} alt={content.imageAlt} maxW="120px" maxH="60px"/>
      </Link>
    </HStack>
  );
};